import React from 'react';
import buttonImage from '../buttonimage.webp';
import backgroundImage from '../background.webp';
import cardBackgroundImage from '../cardbackground.webp';

function Unknown({ goBack, goHome, handleSaveProgress }) {
    const handleSave = async () => {
        if (typeof handleSaveProgress === 'function') {
            await handleSaveProgress('unknown', null, false);
            alert('Session progress has been saved successfully!');
        }
    };

    return (
        <>
            <style>
                {`
                @media (max-width: 600px) {
                    .unknown-btn-row {
                        flex-direction: row !important;
                        gap: 6px !important;
                    }
                    .unknown-btn {
                        width: 32vw !important;
                        min-width: 0 !important;
                        max-width: 100px !important;
                        padding: 10px 0 !important;
                        font-size: 16px !important;
                    }
                }
                `}
            </style>
            <div style={{
                backgroundImage: `url(${backgroundImage})`,
                backgroundSize: 'cover',
                backgroundRepeat: 'no-repeat',
                minHeight: '100vh',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                padding: '16px',
            }}>
                {/* unknown*/}
                <h3 style={{
                    fontFamily: 'Times New Roman, Times, serif',
                    fontSize: '24px',
                    fontWeight: 'bold',
                    color: 'black',
                    marginBottom: '32px',
                }}>
                    Unknown
                </h3>

                {/* Session Helper Cards Row */}
                <div
                    className="unknown-session-helper-row"
                    style={{
                        display: 'flex',
                        flexDirection: window.innerWidth <= 600 ? 'column' : 'row',
                        gap: '16px',
                        width: '100%',
                        maxWidth: '600px',
                        marginBottom: '16px',
                    }}
                >
                    {/* Left Card */}
                    <div style={{
                        flex: 1,
                        border: '2px solid black',
                        borderRadius: '10px',
                        padding: '16px',
                        textAlign: 'left',
                        backgroundImage: `url(${cardBackgroundImage})`,
                        backgroundSize: 'cover',
                        boxShadow: '3px 3px 5px rgba(0,0,0,0.3)',
                        marginBottom: window.innerWidth <= 600 ? '16px' : 0,
                    }}>
                        <div style={{ fontFamily: 'Times New Roman, Times, serif', fontWeight: 'bold', fontSize: '18px', marginBottom: '10px', textAlign: 'center' }}>*Session Helper*</div>
                        <div style={{ fontFamily: 'Times New Roman, Times, serif', fontWeight: 'bold', fontSize: '16px', margin: 0 }}>
                            <div>• Limitless Possibilities exist</div>
                            <div>• Even when we try, some things are out of our control. The control just causes us discomfort.</div>
                            <div>• If you knew everything already there would not be the excitement of surprise or discovery to experience ever again</div>
                            <div>• The divine orchestration can offer unlimited new experiences that we cannot even imagine.</div>
                            <div>• Fear of the unknown can elicit varied coping strategies in people.</div>
                            <div>• It could always turn out far better than you expect.</div>
                        </div>
                    </div>
                    {/* Right Card */}
                    <div style={{
                        flex: 1,
                        border: '2px solid black',
                        borderRadius: '10px',
                        padding: '16px',
                        textAlign: 'left',
                        backgroundImage: `url(${cardBackgroundImage})`,
                        backgroundSize: 'cover',
                        boxShadow: '3px 3px 5px rgba(0,0,0,0.3)',
                    }}>
                        <div style={{ fontFamily: 'Times New Roman, Times, serif', fontWeight: 'bold', fontSize: '18px', marginBottom: '10px', textAlign: 'center' }}>*Session Helper*</div>
                        <div style={{ fontFamily: 'Times New Roman, Times, serif', fontWeight: 'bold', fontSize: '16px', margin: 0 }}>
                            <div>1. Are you open to the limitless possibilities that exist?</div>
                            <div>2. What would be so bad about it if you do not know what will happen next?</div>
                            <div>3. If all experiences exist, why not yours?</div>
                            <div>4. Is it possible that it could turn out better than you expect?</div>
                            <div>5. Could you be limiting yourself with how you are thinking, feeling, or believing about that?</div>
                            <div>6. Where can you surrender control in your life?</div>
                        </div>
                    </div>
                </div>

                {/* Cards */}
                <div style={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    gap: '16px',
                    width: '100%',
                    maxWidth: '600px',
                }}>
                    {/* Card 1 */}
                    <div style={{
                        width: '100%',
                        border: '2px solid black',
                        borderRadius: '10px',
                        padding: '16px',
                        textAlign: 'center',
                        backgroundImage: `url(${cardBackgroundImage})`,
                        backgroundSize: 'cover',
                        boxShadow: '3px 3px 5px rgba(0,0,0,0.3)',
                    }}>
                        <p style={{
                            fontFamily: 'Times New Roman, Times, serif',
                            fontSize: '16px',
                            fontWeight: 'bold',
                            color: 'black',
                            textAlign: 'center',
                            lineHeight: '1.5',
                            marginBottom: '16px',
                        }}>
                            Sometimes we encounter the unknown. This can be a space of uncertainty, curiosity, or even opportunity. Embracing the unknown can help us grow, adapt, and discover new strengths within ourselves. It is fairly common to have fear come up in response to the things we do not know about. It is also common to use control as a coping strategy when we have fear of the unknown, or even fear of what is known.  This coping strategy in particular is disturbed by the limitless possibilities that exist at any given time.
                        </p>
                    </div>

                    {/* Card 2 */}
                    <div style={{
                        width: '100%',
                        border: '2px solid black',
                        borderRadius: '10px',
                        padding: '16px',
                        textAlign: 'center',
                        backgroundImage: `url(${cardBackgroundImage})`,
                        backgroundSize: 'cover',
                        boxShadow: '3px 3px 5px rgba(0,0,0,0.3)',
                    }}>
                        <p style={{
                            fontFamily: 'Times New Roman, Times, serif',
                            fontSize: '16px',
                            color: 'black',
                        }}>
                            Some of what is in the unknown is just what we have not realized yet.  Through my self reflection journey I was able to see how when we are unprocessed on a topic, whatever our coping method is will be causing pain or discomfort for ourselves or other.  Coping really just displaces the pain and it often goes under the radar until we have reason to heal ourselves and alleviate the pattern of coping. <br />The unknown can also contain our potential.  It can be hard to consider potentials when we are already busy just trying to survive.  When we are busy just trying to survive the idea of potential is not even in front of us.  It is completely understandable that we might be intimidated by what is out of our control when we are just trying to survive and feel safe in the world. 
                        </p>
                    </div>

                    {/* Card 3 */}
                    <div style={{
                        width: '100%',
                        border: '2px solid black',
                        borderRadius: '10px',
                        padding: '16px',
                        textAlign: 'center',
                        backgroundImage: `url(${cardBackgroundImage})`,
                        backgroundSize: 'cover',
                        boxShadow: '3px 3px 5px rgba(0,0,0,0.3)',
                    }}>
                        <p style={{
                            fontFamily: 'Times New Roman, Times, serif',
                            fontSize: '16px',
                            color: 'black',
                        }}>
                            Allow yourself to be present with the unknown and see what insights or possibilities arise. <br /> Limitless possibilities exist. <br /> Instead of feeling intimidated by that vast unknown it is possible to channel it into creativity. Exploring creativity can unlock new possibilities in our lives. <br />
How often do you allow time for creativity in your life? Do you feel comfortable with the receptive process of being inspired to create something new?
 Do you need your creativity to be seen? Do you create for yourself or for others?

                        </p>
                    </div>
                    {/* New Card with Confusion Meme image */}
                    <div style={{
                        width: '100%',
                        border: '2px solid black',
                        borderRadius: '10px',
                        padding: '16px',
                        textAlign: 'center',
                        backgroundImage: `url(${cardBackgroundImage})`,
                        backgroundSize: 'cover',
                        boxShadow: '3px 3px 5px rgba(0,0,0,0.3)',
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        justifyContent: 'center',
                        marginBottom: '16px'
                    }}>
                        <img
                            src="/images/confusionmeme.webp"
                            alt="Confusion Meme"
                            style={{
                                width: '100%',
                                maxWidth: '360px',
                                height: 'auto',
                                marginBottom: '12px',
                                borderRadius: '8px',
                                border: '1px solid #4B5563',
                                objectFit: 'contain',
                                display: 'block',
                                marginLeft: 'auto',
                                marginRight: 'auto'
                            }}
                        />
                    </div>
                </div>

                {/* Navigation Buttons */}
                <div
                    className="unknown-btn-row"
                    style={{
                        display: 'flex',
                        justifyContent: 'center',
                        gap: '16px',
                        marginTop: '32px',
                    }}>
                    <button
                        className="unknown-btn"
                        style={{
                            backgroundImage: `url(${buttonImage})`,
                            backgroundSize: 'cover',
                            border: '2px solid black',
                            borderRadius: '10px',
                            padding: '10px 20px',
                            width: '120px',
                            fontFamily: 'Times New Roman, Times, serif',
                            fontSize: '16px',
                            fontWeight: 'bold',
                            boxShadow: '3px 3px 5px rgba(0,0,0,0.3)',
                        }}
                        onClick={goBack}
                    >Back</button>
                    <button
                        className="unknown-btn"
                        style={{
                            backgroundImage: `url(${buttonImage})`,
                            backgroundSize: 'cover',
                            border: '2px solid black',
                            borderRadius: '10px',
                            padding: '10px 20px',
                            width: '120px',
                            fontFamily: 'Times New Roman, Times, serif',
                            fontSize: '16px',
                            fontWeight: 'bold',
                            boxShadow: '3px 3px 5px rgba(0,0,0,0.3)',
                        }}
                        onClick={goHome}
                    >Home</button>
                    <button
                        className="unknown-btn"
                        style={{
                            backgroundImage: `url(${buttonImage})`,
                            backgroundSize: 'cover',
                            border: '2px solid black',
                            borderRadius: '10px',
                            padding: '10px 20px',
                            width: '120px',
                            fontFamily: 'Times New Roman, Times, serif',
                            fontSize: '16px',
                            fontWeight: 'bold',
                            boxShadow: '3px 3px 5px rgba(0,0,0,0.3)',
                        }}
                        onClick={handleSave}
                    >Save</button>
                </div>
            </div>
        </>
    );
}

export default Unknown;
